import { render, staticRenderFns } from "./NewMainTableAdsManager.vue?vue&type=template&id=5d05d8f0&scoped=true&"
import script from "./NewMainTableAdsManager.vue?vue&type=script&lang=ts&"
export * from "./NewMainTableAdsManager.vue?vue&type=script&lang=ts&"
import style0 from "./NewMainTableAdsManager.vue?vue&type=style&index=0&id=5d05d8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05d8f0",
  null
  
)

export default component.exports